import { Badge } from 'components/Badge/Badge'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell, RightCell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { useMemo, useState } from 'react'
import { Button, ColoredDot, Flex, H1WithBack, MainHeadline, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import {
    IIncidentRow,
    INCIDENT_SEVERITY_COLORS,
    INCIDENT_STATUS_COLORS,
    INCIDENT_STATUS_LABELS,
    IncidentSeverity,
    IncidentStatus,
} from 'types/incidents.interface'
import { MOCK_INCIDENTS } from './incidentsData'
import { RaiseIncidentModal } from './RaiseIncidentModal'

const columns: IHonestTableColumn<IIncidentRow>[] = [
    {
        id: 'severity',
        header: 'Severity',
        sticky: true,
        minWidth: '4rem',
        cell: (item) => (
            <Badge hexColor={INCIDENT_SEVERITY_COLORS[item.severity]}>
                <BodyText>{item.severity}</BodyText>
            </Badge>
        ),
    },
    {
        id: 'timestamp',
        header: 'Time',
        minWidth: '10rem',
        cell: (item) => <OtherText grey>{item.timestamp}</OtherText>,
    },
    {
        id: 'incident',
        header: 'Incident',
        minWidth: '18rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.title}</BodyText>
                <OtherText grey>{item.location}</OtherText>
            </Cell>
        ),
    },
    {
        id: 'spacer',
        header: '',
        fill: true,
        cell: () => null,
    },
    {
        id: 'status',
        header: 'Status',
        align: 'right',
        minWidth: '10rem',
        cell: (item) => {
            const color = INCIDENT_STATUS_COLORS[item.status]
            return (
                <RightCell>
                    <Badge hexColor={color}>
                        <Flex gap='0.5rem' center>
                            <ColoredDot color={color} />
                            <BodyText>{INCIDENT_STATUS_LABELS[item.status]}</BodyText>
                        </Flex>
                    </Badge>
                </RightCell>
            )
        },
    },
]

const filterBySeverity = (rows: IIncidentRow[], severity: string) => {
    if (severity === 'all') return rows
    return rows.filter((row) => row.severity === severity)
}

const filterByStatus = (rows: IIncidentRow[], status: string) => {
    if (status === 'all') return rows
    return rows.filter((row) => row.status === status)
}

export const Incidents = () => {
    const [modalOpen, setModalOpen] = useState(false)
    const [severityFilter, setSeverityFilter] = useState('all')
    const [statusFilter, setStatusFilter] = useState('all')

    const filteredIncidents = useMemo(
        () => filterByStatus(filterBySeverity(MOCK_INCIDENTS, severityFilter), statusFilter),
        [severityFilter, statusFilter],
    )

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between width='100%' mb='16'>
                    <H1WithBack title='Incidents' arrow />
                    <Button orange onClick={() => setModalOpen(true)}>
                        Raise Incident
                    </Button>
                </Flex>
                <HonestTable columns={columns} data={filteredIncidents} keyField='id' />
            </PageWrapper>
            {modalOpen && <RaiseIncidentModal closeModal={() => setModalOpen(false)} />}
        </>
    )
}
